import AbstractVideoProcessor from './AbstractVideoProcessor';
import EventManager from '../../EventManager';

export default class TizenVideoProcessor extends AbstractVideoProcessor {
  constructor(video1, video2, options) {
    super(video1, video2, options);
    this.eventManager = new EventManager();
    this.bindEvents();
  }

  bindEvents() {
    this.subscriptions = [];

    for (const video of [this.video1, this.video2]) {
      video.muted = true;

      const videoOnEnded = this.videoOnEnded.bind(this, video);
      const videoOnError = this.videoOnError.bind(this, video);
      const videoOnPlay = this.videoOnPlay.bind(this, video);

      this.eventManager.bindEvent(video, 'ended', videoOnEnded);
      this.eventManager.bindEvent(video, 'error', videoOnError);
      this.eventManager.bindEvent(video, 'play', videoOnPlay);
    }
  }

  play(src) {
    super.play(src);
  }

  bindEvent(element, eventName, event) {
    element.addEventListener(eventName, event);
    this.subscriptions.push({ element, event: eventName, func: event });
  }

  videoOnEnded(video) {
    clearTimeout(this.skipTimeout);
    this.emitter.emit('video:ended', video);
  }

  videoOnError(video, error) {
    this.emitter.emit('video:error', {video, error});
  }

  videoOnPlay(video) {
    this.emitter.emit('video:play', video);
  }

  skipVideo(video) {
    this.videoOnEnded(video);
    this.stop(video);
  }

  destroy() {
    this.eventManager.unsubscribe();
  }
}
